var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { TextField } from '@honeycomb/ui-core';
import { usePrevious } from '@honeycomb/data';
import { useDebounce } from '../../utils/useDebounce';
import { FilterAccordion } from './FilterAccordion';
export function TextFilter(_a) {
    var { id, heading, onChange, value: valueProp } = _a, other = __rest(_a, ["id", "heading", "onChange", "value"]);
    // To make filter editing more performant, we update local state and debounce changes to the parent.
    const [value, setValue] = useState(valueProp);
    const prevValueProp = usePrevious(valueProp);
    const debouncedOnChange = useDebounce(({ value: newValue }) => {
        onChange(id, newValue);
    }, 500);
    const handleChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        debouncedOnChange({ value: newValue });
    };
    // Handle reset scenario
    useEffect(() => {
        if (valueProp !== prevValueProp) {
            setValue(valueProp);
        }
    }, [valueProp, prevValueProp]);
    return (React.createElement(FilterAccordion, Object.assign({ id: id, heading: heading }, other),
        React.createElement(TextField, { onChange: handleChange, variant: "alternative", "data-id": "filter-text", value: value !== null && value !== void 0 ? value : '', placeholder: "Name" })));
}
